import {useApp} from "../../app.context";
import {useState} from "react";
import {useIntegrator} from "../../integrator.context";
import {AddSoundCommand} from "../../commands/addSound.command";
import NumberInputLabel from "../../elements/numberInputLabel.element";
import {UpdateSoundCommand} from "../../commands/updateSound.command";
import {SoundMetadata, SoundTypes} from "../../models/remoteConstants.model";
import AudioPlayer from 'react-h5-audio-player';
import '../../styles/audio.css';
import SoundAsset from "../../elements/soundAsset";
import TextArea from "../../elements/textArea.element";
import {RemoveSoundCommand} from "../../commands/removeSound.command";
import BooleanInput from "../../elements/booleanInput.element";
import List from "../../elements/list";

type SoundDictionary = { [key: string]: SoundMetadata };

function SoundsEditorView() {
    const {state} = useIntegrator();

    function getSoundsByType(type: string): SoundDictionary {
        const dict: SoundDictionary = {};
        for (const id of Object.keys(state.sounds)) {
            const sound = state.sounds[id];
            if (sound.type === type) {
                dict[id] = sound;
            }
        }

        return dict;
    }

    return (
        <div className={'layout horizontal stretch'} style={{gap: 10, flexGrow: 1}}>
            <SoundsCategory title={SoundTypes[0]} sounds={getSoundsByType(SoundTypes[0])}/>
            <SoundsCategory title={SoundTypes[1]} sounds={getSoundsByType(SoundTypes[1])}/>
            <SoundsCategory title={SoundTypes[2]} sounds={getSoundsByType(SoundTypes[2])}/>
        </div>
    )
}

function SoundsCategory(props: {title: string, sounds: SoundDictionary}) {
    const {executeCommand} = useIntegrator();
    const {setNotification} = useApp();
    const [newKey, setNewKey] = useState<string>('');

    function addNewSound() {
        if (newKey === '') {
            setNotification({
                title: 'Invalid Input',
                message: 'Please enter a valid key.'
            })
            return;
        }

        if (props.sounds !== undefined && props.sounds !== null && newKey in props.sounds) {
            setNotification({
                title: 'Key Already Exists',
                message: 'Please enter a new key.'
            })
            return;
        }

        executeCommand(new AddSoundCommand(newKey, props.title));
        setNewKey('');
    }

    return (
        <div className={'layout vertical flex-grow gap'}>
            <List title={props.title} headerClassName={'box'} elements={Object.keys(props.sounds)} component={sound => {
                const value = props.sounds[sound];
                if (value === undefined) {
                    return <></>
                }
                console.log(value)
                return <SoundItem id={sound} metadata={value}/>
            }} search={element => element} keyFor={element => element}/>
            <div className={'layout vertical gap'}>
                <input placeholder={'Enter key...'} value={newKey} onChange={v => setNewKey(v.target.value)}/>
                <button onClick={() => addNewSound()}>Add New Sound</button>
            </div>
        </div>
    )
}

function SoundItem(props: {id: string, metadata: SoundMetadata}) {
    const {executeCommand} = useIntegrator();
    const {getLocalizationValue, getSoundUrl, confirmDelete} = useApp();

    return (
        <div className={'box'} style={{opacity: props.metadata.active ? 1 : 0.5}}>
            <div className={'layout vertical'} style={{gap: 10}}>
                <div className={'layout horizontal stretch'}>
                    <p className={'flex-grow'}>{getLocalizationValue(props.id)}</p>
                    <BooleanInput value={props.metadata.active} onChange={(value) => {
                        props.metadata.active = value;
                        executeCommand(new UpdateSoundCommand(props.id, props.metadata));
                    }}/>
                    <button onClick={async () => {
                        if (await confirmDelete(getLocalizationValue(props.id), 'sound'))
                            executeCommand(new RemoveSoundCommand(props.id));
                    }}>
                        <span className={'fa-solid fa-trash'}/>
                    </button>
                </div>
                <TextArea value={props.metadata.description} placeholder={'Enter description...'} onChange={v => {
                    props.metadata.description = v;
                    executeCommand(new UpdateSoundCommand(props.id, props.metadata));
                }}/>
                <SoundAsset id={props.id} upload={true} style={{width: '100%', height: 60,
                    backgroundColor: 'transparent', border: 'solid 1px var(--overlay-color)'}}
                />
                <AudioPlayer
                    src={getSoundUrl(props.id)}
                    volume={props.metadata.volume / 100}
                    showFilledVolume={true}
                    onVolumeChange={e => {
                        const value = (e.target as any).volume;
                        const volume = Math.round(value * 100);
                        if (volume === props.metadata.volume) {
                            return;
                        }

                        props.metadata.volume = volume;
                        executeCommand(new UpdateSoundCommand(props.id, props.metadata));
                    }}
                    onError={e => console.log(e)}
                />
                <div className={'layout vertical gap'}>
                    <p className={'text header'}>Import Settings</p>
                    <NumberInputLabel title={'Start Delay'}
                                      tooltip={'The sound will start in every x seconds for Ambient Effects.'}
                                      value={props.metadata.startDelay} onChange={v => {
                        props.metadata.startDelay = v;
                        executeCommand(new UpdateSoundCommand(props.id, props.metadata));
                    }}/>
                    <NumberInputLabel title={'Delay'}
                                      tooltip={'The sound will repeat every x seconds for Ambient Effects.'}
                                      value={props.metadata.delay} onChange={v => {
                        props.metadata.delay = v;
                        executeCommand(new UpdateSoundCommand(props.id, props.metadata));
                    }}/>
                </div>
            </div>
        </div>
    )
}

export default SoundsEditorView;